/**
 * dApps need retrieve the provider from the the host environment, but it may fail to retrieve the provider.
 * ProviderNoFoundError should be thrown when a operation requires a provider, but there's no provider.
 */
export class ProviderNoFoundError extends Error {
    constructor(message = 'Provider not found') {
        super(message);
        this.name = ProviderNoFoundError.name;
        Object.setPrototypeOf(this, ProviderNoFoundError.prototype);
    }
}
export const isChainId = (chainIdOrChainParameter) => {
    return typeof chainIdOrChainParameter === 'number';
};
export const isAddChainParameter = (chainIdOrChainParameter) => {
    return !isChainId(chainIdOrChainParameter);
};
